// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-list, ion-list.list-ios {
  margin: 0;
  padding: 0;
}

ion-item-divider .title, ion-item ion-label .title {
  border-bottom: 1px solid #8b8b8b;
}

ion-item-divider {
  border: 0;
}

ion-item-divider .title {
  color: #8b8b8b;
}

.title.active {
  background: var(--button-a-background);
  color: var(--button-a-text);
}

ion-item, ion-item-divider {
  background: #fff;
}
ion-item ion-label, ion-item-divider ion-label {
  width: 100%;
  height: 100%;
  margin: 0;
}
ion-item ion-label .title, ion-item-divider ion-label .title {
  padding: 10px 5px;
  font-size: 16px;
}
ion-item ion-label p span, ion-item-divider ion-label p span {
  margin: 0 5px;
}

.step_0 ion-item ion-label .title, .step_0 ion-item-divider ion-label .title {
  padding-right: 5px;
}

.step_1 ion-item ion-label .title, .step_1 ion-item-divider ion-label .title {
  padding-right: 15px;
}

.step_2 ion-item ion-label .title, .step_2 ion-item-divider ion-label .title {
  padding-right: 25px;
}

.step_3 ion-item ion-label .title, .step_3 ion-item-divider ion-label .title {
  padding-right: 35px;
}

.step_4 ion-item ion-label .title, .step_4 ion-item-divider ion-label .title {
  padding-right: 45px;
}

.step_5 ion-item ion-label .title, .step_5 ion-item-divider ion-label .title {
  padding-right: 50px;
}`, "",{"version":3,"sources":["webpack://./src/core/pages/catalog-list/components/catalog-model/catalog-model.component.scss"],"names":[],"mappings":"AAKA;EACE,SAAA;EACA,UAAA;AAJF;;AAOA;EACE,gCAAA;AAJF;;AAOA;EACE,SAAA;AAJF;;AAOA;EACE,cAAA;AAJF;;AAOA;EACE,sCAAA;EACA,2BAAA;AAJF;;AAOA;EACE,gBAAA;AAJF;AAOE;EACE,WAAA;EACA,YAAA;EAYA,SAAA;AAhBJ;AAMI;EAKE,iBAAA;EACA,eAAA;AARN;AAeM;EACE,aAAA;AAbR;;AAqBI;EACE,kBAAA;AAlBN;;AA0BI;EACE,mBAAA;AAvBN;;AA+BI;EACE,mBAAA;AA5BN;;AAqCI;EACE,mBAAA;AAlCN;;AA2CI;EACE,mBAAA;AAxCN;;AAiDI;EACE,mBAAA;AA9CN","sourcesContent":["ion-icon {\n  //position: absolute;\n  //top: 10px;\n}\n\nion-list, ion-list.list-ios {\n  margin: 0;\n  padding: 0;\n}\n\nion-item-divider .title, ion-item ion-label .title {\n  border-bottom: 1px solid #8b8b8b;\n}\n\nion-item-divider {\n  border: 0;\n}\n\nion-item-divider .title {\n  color: #8b8b8b;\n}\n\n.title.active {\n  background: var(--button-a-background);\n  color: var(--button-a-text);\n}\n\nion-item, ion-item-divider {\n  background: #fff;\n  //position: relative;\n\n  ion-label {\n    width: 100%;\n    height: 100%;\n\n    .title {\n      //ion-icon{\n      //  height: auto;\n      //}\n\n      padding: 10px 5px;\n      font-size: 16px;\n    }\n\n    //padding: 0 30px;\n    margin: 0;\n\n    p {\n      span {\n        margin: 0 5px;\n      }\n    }\n  }\n}\n\n.step_0 {\n  ion-item, ion-item-divider {\n    ion-label .title {\n      padding-right: 5px;\n      //border-color: #0b3e6f;\n    }\n  }\n}\n\n.step_1 {\n  ion-item, ion-item-divider {\n    ion-label .title {\n      padding-right: 15px;\n      //border-color: #0b3e6f;\n    }\n  }\n}\n\n.step_2 {\n  ion-item, ion-item-divider {\n    ion-label .title {\n      padding-right: 25px;\n      //border-color: #ac1f25;\n    }\n\n  }\n}\n\n.step_3 {\n  ion-item, ion-item-divider {\n    ion-label .title {\n      padding-right: 35px;\n      //border-color: #1d4001;\n    }\n\n  }\n}\n\n.step_4 {\n  ion-item, ion-item-divider {\n    ion-label .title {\n      padding-right: 45px;\n      //border-color: #7e57ff;\n    }\n\n  }\n}\n\n.step_5 {\n  ion-item, ion-item-divider {\n    ion-label .title {\n      padding-right: 50px;\n      //border-color: #322b1d;\n    }\n\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
